import { FC, useState } from 'react';
import { SelectFilter, SelectFilterProps } from 'components/filters';
import { useShopUsers } from 'store/shop-users';

type Props = Omit<
  SelectFilterProps<string, true>,
  'options' | 'loadingOptions' | 'asyncSearch' | 'onSearch' | 'multiple'
> & {
  optionKey?: 'employeeId' | 'shopUserId';
};

export const AdminShopUsersFilter: FC<Props> = ({
  optionKey = 'employeeId',
  ...props
}) => {
  const [search, setSearch] = useState('');

  const { data: shopUsers, isLoading } = useShopUsers({ search });

  return (
    <SelectFilter
      {...props}
      options={shopUsers?.items.map((shopUser) => ({
        key: optionKey === 'shopUserId' ? shopUser.id : shopUser.employee.id,
        label: shopUser.employee.fullName,
      }))}
      loadingOptions={isLoading}
      onSearch={setSearch}
      multiple
      asyncSearch
    />
  );
};
